import { getWhatsappConversationData, sendMessageConversation} from 'api/services/communication';
import React, { useContext, useEffect, useState } from 'react';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { AxiosResponse } from 'axios';
import { UserProfileContext } from 'context/UserProfile';
import SearchContainer from 'components/SearchContainer';
import { StyledChatInput} from 'views/chats/styles';
import SendRoundedIcon from "@mui/icons-material/SendRounded";
import { Box, Button, CircularProgress, Divider, IconButton, Tooltip, Typography } from '@mui/material';
import moment from 'moment';
import { Add, AddCircleOutlineRounded, DownloadDone, Message, MessageRounded } from '@mui/icons-material';
import TemplateSelection from './templateSelection';
import AddClientPopUp from './addClientPopUp';
import { getCountryCode } from 'validations/phoneNumbr';
import { downloadPdf,word,xls } from 'assets';


const Conversation = () => {
    const { data: uData } = useContext(UserProfileContext);
    const [selectedNumber, setSelectedNumber] = useState<string | null>(null);
    const [message, setMessage] = useState('');
    const [open, setOpen] = useState(false)
    const [addClientOpen, setAddClientOpen] = useState(false);
    const [search, setSearch] = useState("");
const queryClient = useQueryClient();

    const { data, isLoading, error } = useQuery<AxiosResponse<any>>([  'whatsappConversation',{
search:search
    }],
      
        getWhatsappConversationData,
    );

    const handleSearch = (e) => {
        setSearch(e);
      }

      const getDateLabel = (dateStr: string) => {
        const date = moment(dateStr);
        if (moment().isSame(date, 'day')) return 'Today';
        if (moment().subtract(1, 'day').isSame(date, 'day')) return 'Yesterday';
        return date.format('DD MMMM YYYY');
      };
      let lastDateLabel: string | null = null;
    const handleClientSelect = (client) => {
        setSelectedNumber(`${getCountryCode(client?.countryCode) || 91}${client?.mobileNumber}`);
        setAddClientOpen(false);
      };

    const { mutate: sendMessage, isLoading: isSending } = useMutation(sendMessageConversation, {
        onSuccess: () => {
            console.log('Message sent successfully');
            setMessage('');
                  queryClient.invalidateQueries('whatsappConversation');

        },
        onError: (err: any) => {
            console.log('Error sending message:', err);
        },
    });

    if (isLoading) return <p>Loading conversations...</p>;
    if (error) return <p>Error fetching conversations.</p>;

    const messages = data?.data || [];
    const uniqueNumbers = Array.from(new Set(messages.map((msg: any) => msg.mobileNumber)));

    const filteredMessages = selectedNumber
        ? messages
              .filter((msg: any) => msg.mobileNumber === selectedNumber)
              .sort((a: any, b: any) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime())
        : [];
       
    // Find the latest message timestamp for the selected number
    const incomingMessages = filteredMessages.filter((msg: any) => msg.direction === 'incoming');
    const latestWindowTime = incomingMessages.length > 0
      ? moment(incomingMessages[incomingMessages.length - 1].windowTime)
      : null;
    
      const isSessionExpired: boolean = !latestWindowTime || moment().isAfter(latestWindowTime);
      
    //   const isSessionExpired: boolean =
    // selectedNumber !== null && (
    //     !latestWindowTime || moment().isAfter(latestWindowTime)
    // );

    return (
        <>

        <div style={{ display: 'flex' }}>
             {/* <Box flex={1}>
                        <Outlet />
                      </Box> */}
            <div style={{ width: '25%', borderRight: '1px solid #ccc', paddingRight: '5px',paddingTop:"10px", height: "600px" }}>
            <Box
  sx={{
    display:"flex",
 "& .MuiTextField-root": {
      minWidth: "270px !important",
      maxWidth: "270px !important",
    },
  }}
>
  <SearchContainer
  value={search}
  debounced
  onChange={setSearch}
  placeHolder="Search by Mobile Number"
/>

            <IconButton title="select client" onClick={() => {
                setAddClientOpen(true);
              }}
               className="no-margin-bottom">
                      <AddCircleOutlineRounded color="primary" />
                    </IconButton>
                    </Box>
                <ul style={{ listStyle: 'none', padding: 0,fontFamily:'initial'}}>
                    {uniqueNumbers.map((number: any) => (
                        <li
                            key={number}
                            onClick={() => setSelectedNumber(number)}
                            style={{
                                cursor: 'pointer',
                                padding: '8px',
                                backgroundColor: selectedNumber === number ? '#EDF0F7' : 'transparent',
                                borderRadius: '5px',
                            }}
                        >
                            {number}
                        </li>
                    ))}
                </ul>
            </div>

            {/* Chat Section */}
            <div style={{ width: '75%', display: 'flex', flexDirection: 'column', height:" 600px"  }}>
                <div style={{ flex: 1, overflowY: 'auto', paddingTop: "0px" ,backgroundColor : "#EDF0F7"}}>
                    <div style={{
                        position: 'sticky',
                        top: '0',
                        backgroundColor: '#fff',
                        padding: '10px',
                        zIndex: 10,
                        borderBottom: '1px solid #ccc',
                    }}>
                      <Box sx={{display:"flex",fontFamily:'initial'}}>
                        <Typography variant='body2'>{selectedNumber}</Typography>
                        {(!latestWindowTime || moment().isAfter(latestWindowTime)) && (
    <Box sx={{ fontWeight: 600, color: 'red' }}>
      (Session Expired)
    </Box>
  )}
    </Box>
                    </div>

                    <div style={{ display: 'flex', flexDirection: 'column', gap: '10px',padding:"4px" }}>
                    {selectedNumber ? (
    filteredMessages.length > 0 ? (
        filteredMessages.map((msg: any, index: number) => {
            const currentDateLabel = getDateLabel(msg.createdAt);
  const showDateDivider = currentDateLabel !== lastDateLabel;
  lastDateLabel = currentDateLabel;

            const isLastMessage = index === filteredMessages.length - 1;

                                return (
                                       
<> 
      {showDateDivider && (
        <Divider textAlign="center" sx={{ my: 1,fontSize:10,fontFamily:"monospace" }}>
         <Typography variant='body2'>{currentDateLabel}</Typography> 
        </Divider>
      )}
                                        <Typography variant='body2'
                                            sx={{
                                                alignSelf: msg.direction === 'incoming' ? 'flex-start' : 'flex-end',
                                                backgroundColor: msg.direction === 'incoming' ? '#FEFEFB' : '#D0D3E4',
                                                padding: '10px',
                                                borderRadius: '8px',
                                                maxWidth: '60%',
                                                wordWrap: 'break-word',
                                                textAlign: 'left',
                                                display:"flex",
                                                flexDirection:"column",
                                                // borderRadius: "15px 40px 40px 10px"
                                            }}
                                        >
                                           {msg.templateName ||msg.message}
                                            {/* {msg.link && (
                                                <>
                                                    <br />
                                                    <img
                                                        src={msg.link}
                                                        alt="WhatsApp Attachment"
                                                        style={{
                                                            maxWidth: '30%',
                                                            maxHeight: '30%',
                                                            borderRadius: '5px',
                                                            marginTop: '5px',
                                                        }}
                                                        onError={(e) => (e.currentTarget.style.display = 'none')}
                                                    />
                                                    <a
                                                        href={msg.link}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        style={{
                                                            color: 'blue',
                                                            textDecoration: 'none',
                                                            display: 'block',
                                                            marginTop: '5px',
                                                        }}
                                                    >
                                                        {msg.link}
                                                    </a>
                                                </>
                                            )} */}
                                       {msg.link && (
  <>
    <br />
    {msg.link.endsWith('.pdf') || msg.type === 'application/pdf' ? (
      <a href={msg.link} target="_blank" rel="noopener noreferrer">
        <img
          src={downloadPdf}
          alt="PDF Document"
          style={{
            maxWidth: '50px',
            maxHeight: '50px',
            cursor: 'pointer',
            marginTop: '5px',
          }}
        />
      </a>
    ) : msg.link.endsWith('.csv') || msg.type === 'text/csv' ? (
      <a href={msg.link} target="_blank" rel="noopener noreferrer">
        {/* <Button variant="outlined" size="small" sx={{ mt: 1 }}>
          Download CSV
        </Button> */}
        <img
          src={xls}
          alt="text/csv"
          style={{
            maxWidth: '50px',
            maxHeight: '50px',
            cursor: 'pointer',
            marginTop: '5px',
          }}
        />
      </a>
    ) : msg.link.endsWith('.xlsx') || msg.type?.includes('spreadsheet') ? (
      <a href={msg.link} target="_blank" rel="noopener noreferrer">
        {/* <Button variant="outlined" size="small" sx={{ mt: 1 }}>
          Download Excel
        </Button> */}
 <img
          src={xls}
          alt="spreadsheet"
          style={{
            maxWidth: '50px',
            maxHeight: '50px',
            cursor: 'pointer',
            marginTop: '5px',
          }}
        />      </a>
    ) : msg.link.endsWith('.doc') ||
      msg.link.endsWith('.docx') ||
      msg?.type === 'application/msword' ||
      msg?.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ? (
      <a href={msg.link} target="_blank" rel="noopener noreferrer">
<img
          src={word}
          alt="word"
          style={{
            maxWidth: '50px',
            maxHeight: '50px',
            cursor: 'pointer',
            marginTop: '5px',
          }}
        />          </a>
    ) : (
      <a href={msg.link} target="_blank" rel="noopener noreferrer">
        <img
          src={msg.link}
          alt="WhatsApp Attachment"
          style={{
            maxWidth: '150px',
            maxHeight: '150px',
            borderRadius: '5px',
            marginTop: '5px',
            cursor: 'pointer',
          }}
          onError={(e) => {
            e.currentTarget.onerror = null;
            e.currentTarget.style.display = 'none';
          }}
        />
      </a>
    )}
  </>
)}



                                            <small style={{ fontSize: '12px', color: '#666' }}>
                                                {moment(msg.createdAt).format('h:mm a')}
                                            </small>
                                            
                                        </Typography>
                                     {isLastMessage && isSessionExpired && (
                // <StyledDayDivider>
                <>
                    <Divider textAlign="center">Session expired</Divider>
                    <Box><Typography>As your session is expired,would you like to send template message to client and activate session. if so, please select template you wanted to send </Typography></Box>
                  
                    </>
                    
                // </StyledDayDivider>  
            )}              

                                        </>
                                );
        })
    ) : (
        <Typography>No messages yet. Start the conversation by sending a Template Message.</Typography>
    )
) : (
    <Typography>Select a number to view messages.</Typography>
)}

                    </div>
                </div>
<Box sx={{display:"flex"}}>
<IconButton onClick={() => setOpen(true)} >
   <Tooltip
  
              title="templates"
            >
            <MessageRounded color='secondary'/>
            </Tooltip>
          </IconButton>
                {/* Chat Input */}
                <StyledChatInput
                    sx={{
                        position: 'sticky',
                        bottom: '0',
                        background: '#fff',
                        padding: '1px',
                        width: '100%',
zIndex:1                    }}
                >
                    <input
                        type="text"
                        placeholder="Type a message..."
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter' && message.trim() && selectedNumber) {
                                sendMessage({ message, mobileNumber: selectedNumber });
                            }
                        }}
                        disabled={!selectedNumber || isSessionExpired} // updated here                        style={{ flex: 2, padding: '25px', margin: "10px", width: '100%', borderRadius: "5px" }}
                    />
                    <div>
                        <IconButton
                            onClick={() => sendMessage({ message, mobileNumber: selectedNumber })}
                            disabled={isSending || !selectedNumber || isSessionExpired } // updated here
                            size="small"
                            color="secondary"
                        >
                            {isSending ? <CircularProgress size={10} /> : <SendRoundedIcon />}
                        </IconButton>
                    </div>
                </StyledChatInput>
                <TemplateSelection open={open} setOpen={setOpen} data={selectedNumber}userData={uData} />
                


                                    </Box>
            </div>
        </div>
        <AddClientPopUp
    open={addClientOpen}
    setOpen={setAddClientOpen}
    onClientSelect={handleClientSelect}
  />

        </>
    );
};

export default Conversation;
